// extracted by mini-css-extract-plugin
export default {"wrapperSpinner":"style_wrapperSpinner__Mb61I","spinner":"style_spinner__zZuFz","preloader":"style_preloader__SVJIX"};